module.exports = __webpack_public_path__ + "img/new_zealand.a3f90d8.webp";